import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CrmApp } from "./CRM Dashboard/CrmApp";

import Home from "./MainWebsite/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-toastify/dist/ReactToastify.css";
import AdminApp from "./AdminDashboard/AdminApp";
import CustomerApp from "./Customer Dashboard/CustomerApp";
import EmployeeApp from "./Employee Dashboard/EmployeeApp";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* Default CRM Dashboard */}
          <Route element={<CrmApp />} path="/*" />
          {/* main website */}
          <Route element={<Home />} path="/" />
          {/* customer dashboard */}
          <Route element={<CustomerApp />} path="/customer/*" />
          {/* employee dashboard */}
          <Route element={<EmployeeApp />} path="/employee/*" />
          {/* Admin Dashboard */}
          <Route element={<AdminApp />} path="admin/*" />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
